import React from 'react';
export function RefreshIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M13 6v3l6-4-6-4v3h-1a9 9 0 109 9h-2a7 7 0 11-7-7h1z"
  }));
}